/**
 * Подставляет значения из объекта в строку.
 * В тексте плейсхолдеры {name} заменяются на значение vars[name].
 *
 * @param text - Строка с плейсхолдерами вида {key}
 * @param vars - Объект с подставляемыми значениями (ключ — имя плейсхолдера без скобок)
 * @returns Строка с подставленными значениями
 *
 * @example
 * render('Скидка {discount}% на {months} месяцев', { discount: 10, months: 3 })
 * // => 'Скидка 10% на 3 месяцев'
 */
export function render(text: string, vars: Record<string, string | number | undefined>): string {
    return Object.entries(vars).reduce(
        (result, [key, value]) => result.replace(new RegExp(`\\{${key}\\}`, 'g'), String(value ?? '')),
        text,
    );
}
